"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batteryTypeDel = batteryTypeDel;
exports.batteryTypeDelByCabinet = batteryTypeDelByCabinet;
exports.batteryTypeList = batteryTypeList;
exports.batteryTypeListByCabinet = batteryTypeListByCabinet;
exports.batteryTypeSave = batteryTypeSave;
exports.batteryTypeSaveByCabinet = batteryTypeSaveByCabinet;
var _fetch = _interopRequireDefault(require("@/utils/fetch"));
/**
 * 电池类型列表
 */
function batteryTypeList(params) {
  return _fetch.default.get("/Supplier/batteryType/getList", params);
}
//
function batteryTypeSave(params) {
  return _fetch.default.post("/Supplier/batteryType/save", params, true);
}

//
function batteryTypeDel(params) {
  return _fetch.default.post("/Supplier/batteryType/del", params, true);
}

/**
 * 电柜电池类型列表
 */
function batteryTypeListByCabinet(params) {
  return _fetch.default.get("/Supplier/batteryType/getListByCabinet", params);
}
function batteryTypeSaveByCabinet(params) {
  return _fetch.default.post("/Supplier/batteryType/saveByCabinet", params, true);
}
function batteryTypeDelByCabinet(params) {
  return _fetch.default.post("/Supplier/batteryType/delByCabinet", params, true);
}